import { FaberApi } from 'api'
import { AxiosPromise } from 'axios'
import { AuditDataType } from 'types/api/faber/customerAuditLog.type'
import {
  BillWaiverAuditLogType,
  GeneralAuditResponseType,
  VoucherAuditLogType
} from 'types/api/faber/customerAuditLog.type'

export interface AdditionalPassengers {
  title: string,
  first_name: string,
  last_name: string,
}

export interface FlightRegistration {
  flight:{
    flight_code: string,
    departure_airport_code: string,
    arrival_airport_code: string,
    departure_date: string,  
  },
  main_passenger: {
    title: string,
    first_name: string,
    last_name: string,
    email: string,
    mobile: string,  
  },
  additional_passengers: AdditionalPassengers[],
  cultureCode: string
}

class CustomerLogApi {
  /**
   * to see all logs for one customer
   */
  static getCustomerLogs(
    userID: string,
    faberToken: string
  ): AxiosPromise<AuditDataType> {
    return FaberApi.httpGet(
      `/audit/subscriptions/v2/${userID}`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    )
  }

  static getSmartDelayForms(userId: string, faberToken: string) {
    return FaberApi.httpGet(
      `/benefit/smartdelay/records/retrieval/${userId}`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    )
  }

  static deleteSmartDelayForms(flightId: string, faberToken: string) {
    return FaberApi.httpDelete(
      `/esim/ops/smartdelay/flightregistration/${flightId}`, 
      {
        Authorization: `Bearer ${faberToken}`
      },
    )
  }

  static getExternalSmartDelayForms(userId: string, faberToken: string) {
    return FaberApi.httpGet(
      `/sim/ext/benefit/smartdelay/records/retrieval/${userId}`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    )
  }


  static getVoucherLogs(
    userId: string,
    faberToken: string
  ): AxiosPromise<GeneralAuditResponseType<VoucherAuditLogType[] | undefined>> {
    return FaberApi.httpGet(
      `/audit/vouchers/${userId}`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    )
  }

  static getWaiverLogs(
    userID: string,
    faberToken: string
  ): AxiosPromise<
    GeneralAuditResponseType<BillWaiverAuditLogType[] | undefined>
  > {
    return FaberApi.httpGet(
      `/audit/waivers/v2/${userID}`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    )
  }
  static createFlightRegistration(
    flightRegistration: FlightRegistration,
    userId: string,
    faberToken: string
  ){
    return FaberApi.httpPost(
      `/esim/ops/smartdelay/flightregistration`,
      { Authorization: `Bearer ${faberToken}`},
      {
        flight_registration: flightRegistration,
        user_id: userId,
      }
    )
  }
}

export default CustomerLogApi
